import { render, staticRenderFns } from "./DPDLabel.vue?vue&type=template&id=97c97f4a&scoped=true"
import script from "./DPDLabel.vue?vue&type=script&lang=js"
export * from "./DPDLabel.vue?vue&type=script&lang=js"
import style0 from "./DPDLabel.vue?vue&type=style&index=0&id=97c97f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c97f4a",
  null
  
)

export default component.exports